"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.fallbackImage = fallbackImage;
exports.isSameFileExt = isSameFileExt;

var _endsWith = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/ends-with"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/index-of"));

var _api = require("../api");

var _support = require("./support");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 暂时不考虑 BFS 和 OSS 的图片处理参数，例如
// BFS:
//   https://host/file.jpg@96w_96h_1c_1s
//   https://host/file.jpg@96w_96h_1c_1s.webp
// OSS:
//   https://host/file.gif?x-oss-process=image/format,png
function isSameFileExt(path, suffix) {
  var _context;

  var queryIndex = (0, _indexOf.default)(path).call(path, '?');
  var pathWithoutQuery = queryIndex < 0 ? path : path.substring(0, queryIndex);
  return (0, _endsWith.default)(_context = pathWithoutQuery.toLowerCase()).call(_context, ".".concat(suffix.toLowerCase()));
}
/**
 * 自动降级处理图片 URL
 * @example
 *   await Supports.init()
 *   fallbackImage(url)
 */


function fallbackImage(url) {
  var newUrl = (0, _api.newURL)(url);

  if (!newUrl) {
    return newUrl;
  }

  if (isSameFileExt(newUrl.pathname, 'avif')) {
    // TODO: 等 web 支持 avif 后，从 xxx.avif 转到 xxx-web.avif
    newUrl.pathname = newUrl.pathname.replace('.avif', '.webp');
  }

  if (isSameFileExt(newUrl.pathname, 'webp') && !_support.Supports.WebP) {
    newUrl.pathname = newUrl.pathname.replace('.webp', '.png');
  }

  return newUrl.toString();
}